<template>
    <div>
        <v-row>
            <ActionDropdown 
                :items="actions"
                context="Income"
                :alvqa="alvqa"
                cols="3"
            />
            <ImportButton
                :items="importOptions"
                context="FileImport"
                cols="3"
                :alvqa="alvqa"
                return-object
                :additional-function="setImportOption"
            />
            <div class="d-flex align-center" style="margin-top: 10px; margin-left: -8px;">
                <ContextHelpIcon 
                    v-if="hasContextHelp"
                    context="PublishingIncomeListpageImportMapping"
                    :alvqa="alvqa + '-import-context-help-icon'"
                />
            </div>
            <v-col 
            cols="4"
            align-self="center"
            class="v-label theme--light mt-3"
        >
            <BaseHeaderStats 
                context="Income" 
                typeStats="LIST"
                :alvqa="alvqa + '-list'"
            />
        </v-col>
        </v-row>

        <!-- Context Help Dialog -->
        <ContextHelpDialog />
    </div>
</template>

<script>
import ImportButton from '@/components/_buttons/ImportButton'
import ActionDropdown from '@/components/_actions/ActionDropdown'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import ContextHelpIcon from '@/components/_buttons/ContextHelpIcon'
import ContextHelpDialog from '@/components/_dialogs/ContextHelpDialog'

export default {
    name: "IncomeTopSlot",
    components: {
        ImportButton,
        ActionDropdown,
        BaseHeaderStats,
        ContextHelpIcon,
        ContextHelpDialog
    },
    data() {
        return {
            alvqa: "publishing-income",
            hasContextHelp: false
        }
    },
    methods: {
        setImportOption(selected) {
            // Reset selected abbreviation
            this.$store.commit('setPublishingIncomeDetailsAbbreviation', null)
            this.$store.dispatch("setSelectedFileImportOption", selected)

            // Abbreviation options
            let options = selected ? selected.mappings : []
            options.sort((a, b) => {
                if (a.disabled === true) return 1; // Put disabled at the end
                if (b.disabled === true) return -1;
            })
            if (options && options.length > 0 && options[0].disabled === false) {
                // Preselect first abbreviation if avaliable
                this.$store.commit('setPublishingIncomeDetailsAbbreviation', options[0].value)
            }
        },
        },
    computed: {
        importOptions() {
            const items = this.$store.getters.getIncomeImporters || [];

            items
                .forEach(item=>item.alvqa = `${this.alvqa}-list-import-dropdown-${item.alvId}`);

            // Remove deprecated Excel import option
            items.sort((itemA, itemB)=>itemA.text<itemB.text?-1:1)
            return items;
        },
        actions() {
            return [
                {
                    text: this.$t('lang_GENERAL_ACTION_OPTION_UPDATE_ERROR_LIST'), 
                    value: 'runErrorLists',
                    alvqa: this.alvqa + '-list-action-dropdown-run-error-list'
                },
                {
                    text: this.$t('lang_GENERAL_ACTION_OPTION_EXPORT_ERROR_LIST'), 
                    value: 'downloadErrorList',
                    alvqa: this.alvqa + '-list-action-dropdown-export-error-list'
                },
                // check GEMA Werkeinstufung / BEW
                {
                    text: this.$t('lang_PUBLISHING_INCOME_ACTION_OPTION_COMPARE_GEMA_BEW'), 
                    value: 'compareGemaBew',
                    alvqa: this.alvqa + '-list-action-dropdown-compare-gema-bew'
                },
                { 
                    text: this.$t('lang_PUBLISHING_INCOME_ACTION_OPTION_MOVE'),
                    value: 'move', 
                    alvqa: this.alvqa + '-list-action-dropdown-move'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_DELETE'), 
                    value: 'delete', 
                    alvqa: this.alvqa + '-list-action-dropdown-delete'
                }
            ]
        }
    },
    async created() {
        this.hasContextHelp = await this.$alvPlugin.checkContextHelpAvailability('PublishingIncomeListpageImportMapping')
    }
}
</script>